// Color definitions matching the original CSS
export const colors = {
  primary: '#6B4DE0',
  primaryHover: '#5A3ED0',
  textPrimary: '#18033C',
  textSecondary: '#4A4A4A',
  error: '#f06163',
  errorBg: '#fdf0ef',
  warning: '#FFA500',
  success: '#10B981',
  border: '#E5E5E5',
  background: '#FFFFFF',
  inputBg: '#FFFFFF',
  link: '#18181B',
  illustration: '#240059',
} as const;

// Spacing scale
export const spacing = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32,
  xl: 40,
  xxl: 48,
} as const;

// Typography
export const typography = {
  h1: {
    fontSize: 40,
    lineHeight: 1.2,
    fontWeight: '700' as const,
    color: colors.textPrimary,
  },
  h2: {
    fontSize: 20,
    lineHeight: 1.4,
    fontWeight: '400' as const,
    color: colors.textSecondary,
  },
  body: {
    fontSize: 16,
    lineHeight: 1.5,
    fontWeight: '400' as const,
    color: colors.textPrimary,
  },
  label: {
    fontSize: 16,
    lineHeight: 1.5,
    fontWeight: '500' as const,
    color: colors.textPrimary,
  },
  link: {
    fontSize: 14,
    lineHeight: 1.5,
    fontWeight: '500' as const,
    color: colors.link,
  },
} as const;

// Border radius
export const borderRadius = {
  small: 8,
  medium: 16,
  button: 100,
} as const;

// Shadows
export const shadows = {
  card: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 24,
    elevation: 5,
  },
  dropdown: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 12,
    elevation: 3,
  },
} as const;
